import { Chip, ChipProps } from "@mui/material";
import React from "react";
import {
  ICustomChipColor,
  ICustomChipProps,
} from "./interfaces/ICustomChipProps";

export const customChipColors: ICustomChipColor[] = [
  "success",
  "warning",
  "error",
  "info",
  "primary",
  "secondary",
];

export const CustomChip: React.FC<ICustomChipProps> = (props) => {
  const { size, content, color, icon, sx, onClick } = props;

  // Function to get light background color based on the color prop
  const getBackgroundColor = (color: ICustomChipColor) => {
    switch (color) {
      case "success":
        return "#E8F5E8"; // Light green
      case "warning":
        return "#FFF4E5"; // Light orange
      case "error":
        return "#FFEBEE"; // Light red
      case "info":
        return "#E3F2FD"; // Light blue
      case "primary":
        return "#E3F2FD"; // Light blue (same as info)
      case "secondary":
        return "#F3E5F5"; // Light purple

      default:
        return "#F5F5F5"; // Light gray for default
    }
  };

  return (
    // <Chip
    //   sx={{
    //     // color: "#fff",
    //     color: "black",
    //     borderRadius: "6px",
    //     pl: "3px",
    //     pr: "3px",
    //     ...sx,
    //   }}
    //   //@ts-ignore
    //   icon={icon}
    //   color={color}
    //   size={size}
    //   label={content}
    //   onClick={onClick}
    // />

    <Chip
      sx={{
        borderRadius: "6px",
        fontWeight: 700,
        textTransform: "uppercase",
        pl: "3px",
        pr: "3px",
        backgroundColor: getBackgroundColor(color),
        color: `${color}.main`,
        border: `1px solid`,
        borderColor: `${color}.main`,
        "& .MuiChip-label": {
          color: `${color}.main`,
        },

        ...sx,
      }}
      icon={icon as React.ReactElement}
      variant="outlined"
      size={size}
      label={content}
      onClick={onClick}
    />
  );
};
